import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pages-result__card" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "pages-result__content-col" }
const _hoisted_4 = { class: "pages-result__mini-kicker" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "pages-result__link",
      href: $props.url
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent($props.contentType))),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($props.kicker), 1 /* TEXT */),
        _createElementVNode("div", { innerHTML: $props.title }, null, 8 /* PROPS */, _hoisted_5)
      ])
    ], 8 /* PROPS */, _hoisted_2)
  ]))
}